// Strip any requirements/conflicts that don't exist in the accessories list
export const cleanAccessories = accessories => {
  const allAccessoryIds = accessories.map(accessory => accessory.id);

  const filterIdsByExistence = accessoryIds =>
    accessoryIds.filter(accessoryId => allAccessoryIds.includes(accessoryId));

  return accessories.map(accessory => ({
    ...accessory,
    requiresSingle: filterIdsByExistence(accessory.requiresSingle),
    requiresAll: filterIdsByExistence(accessory.requiresAll),
    conflicts: filterIdsByExistence(accessory.conflicts),
  }));
};

export const getAccessoryImage = (accessories, accessory) => {
  const accessoryIds = accessories.map(acc => acc.id);

  return (
    accessory.bikeImages.find(accessoryImage =>
      accessoryImage.restrictions.find(restriction => accessoryIds.includes(restriction))
    ) ||
    accessory.bikeImages.find(bikeImage => !bikeImage.restrictions.length) ||
    accessory.bikeImages[0]
  );
};

export const getAccessoriesMinusPack = (pack, accessories) => {
  const packPartIds = pack.parts.map(accessory => accessory.id);
  const accessoryIdsToRemove = accessories
    .filter(accessory => packPartIds.includes(accessory.id) && accessory.quantity === 1)
    .map(accessory => accessory.id);

  const updatedAccessories = accessories
    .filter(accessory => !accessoryIdsToRemove.includes(accessory.id))
    // need to ensure that if user has added 2 or more of an accessory that we only take the one in the pack off
    .map(accessory => ({
      ...accessory,
      quantity: pack.parts.includes(accessory.id) ? accessory.quantity - 1 : accessory.quantity,
    }));

  return updatedAccessories;
};

export const isAccessoryPending = (bikeAccessories, accessory) => {
  const { requiresSingle, requiresAll, conflicts } = accessory;
  let isPending = false;

  const bikeAccessoryIds = bikeAccessories.map(acc => acc.id);

  if (requiresSingle.length) {
    const needsAccessory = !requiresSingle.some(accessoryId => bikeAccessoryIds.includes(accessoryId));

    isPending = needsAccessory;
  }

  if (requiresAll.length) {
    const newRequiresAll = requiresAll.filter(accessoryId => !bikeAccessoryIds.includes(accessoryId));
    isPending = isPending || newRequiresAll.length;
  }

  const newConflicts = conflicts.filter(conflictingAccessoryId =>
    bikeAccessories.find(acc => acc.id === conflictingAccessoryId)
  );

  const existingAccessoryConflicts = bikeAccessories.filter(acc => acc.conflicts.includes(accessory.id));

  if (newConflicts.length || existingAccessoryConflicts.length) {
    isPending = true;
  }

  return isPending;
};

export const isAccessoryConflicting = (accessories, accessory) => {
  const { conflicts } = accessory;

  const newConflicts = conflicts.filter(conflictingAccessoryId =>
    accessories.find(acc => acc.id === conflictingAccessoryId)
  );
  const existingAccessoryConflicts = accessories.filter(acc => acc.conflicts.includes(accessory.id));

  return newConflicts.length || existingAccessoryConflicts.length;
};

export const getAccessoriesTotal = (prevTotal, accessory) => prevTotal + accessory.price * (accessory.quantity || 1);

export const formatAccessory = accessory => ({
  ...accessory,
  quantity: 1,
});
